// extracted by mini-css-extract-plugin
export default {"settings":"Vfvr1","divider":"ToUDj"};